// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-banner{color:#fff}.job-banner__title{text-align:center;font-family:Zilla Slab,sans-serif;font-weight:700;font-size:24px;line-height:29px;margin-bottom:24px}.job-banner__button{max-width:247px;width:100%;margin:0 auto}@media (min-width:768px){.job-banner__title{font-size:28px;line-height:34px;text-align:left}.job-banner__button{margin:0}}@media (min-width:1280px){.job-banner{max-width:949px;margin:0 auto}.job-banner__title{font-size:32px;line-height:38px}}", ""]);
// Exports
module.exports = exports;
